<script setup lang="ts">
import type { PropertiesListingMapState } from '#imports';

import { HEADER_OFFSET_CONFIG } from '~/composables/useDragToBottom/constants';
import { useNavigationStore } from '~/store/navigationStore';
import { cn } from '~/utils';
import { PROPERTIES_LISTING_METHODS } from '~~/utils/symbols';

const route = useRoute();
const isMapView = computed<boolean>(() => route.path.includes('/imoveis'));

const { isHeaderVisible } = useNavigationStore();

const { variant, transform } = useHeaderAnimation({
	headerHeightInPx: HEADER_OFFSET_CONFIG.DESKTOP_HEIGHT,
	variants: ['primary', 'primary']
});

useState<PropertiesListingMapState>('properties-listing-map', () => ({
	fetchedData: null,
	filters: {
		transactionType: 'sell',
		countPluscodes: [],
		propertyTypes: [],
		locationSlug: 'sao-paulo-sp-brasil'
	},
	pluscodes: {},
	mapConfig: {
		zoom: 14,
		maxZoom: 17,
		minZoom: 8,
		bounds: [],
		center: {
			lat: -23.585,
			lng: -46.685
		}
	}
}));

provide(PROPERTIES_LISTING_METHODS, {
	updateMapFilters: () => {}
});

const computedClasses = computed(() => {
	return cn(
		`h-[${HEADER_OFFSET_CONFIG.MOBILE_HEIGHT}px]`,
		`lg:h-[${HEADER_OFFSET_CONFIG.DESKTOP_HEIGHT}px]`
	);
});
</script>

<template>
	<div
		class="fixed top-0 z-[49] w-full divide-y divide-primary-light-4"
		:class="computedClasses"
	>
		<div
			:class="
				cn({
					'z-50 lg:z-[60]': isHeaderVisible
				})
			"
			class="relative flex h-[60px] w-full flex-col transition-transform duration-300 ease-in-out"
		>
			<PortalHeader
				:variant="variant"
				:transform="transform"
				:is-visible="true"
				:has-header-overlay="true"
				:class="[
					'h-[60px] md:h-20',
					{
						'z-50 lg:z-[60]': isMapView,
						'z-50': !isMapView
					}
				]"
			/>
		</div>
	</div>

	<div class="pt-[60px] lg:pt-20">
		<slot />
	</div>
</template>
